// Authentication UI for Parent Application
import { AuthManager } from './AuthManager';

export class AuthUI {
  constructor(private authManager: AuthManager) {}

  renderLoginButton(container: HTMLElement): void {
    const button = document.createElement('button');
    button.textContent = 'Sign In';
    button.className = 'auth-button login-button';
    button.onclick = () => this.authManager.login();
    container.appendChild(button);
  }

  renderUserInfo(container: HTMLElement): void {
    const user = this.authManager.getUser();
    if (!user) return;

    const userInfo = document.createElement('div');
    userInfo.className = 'user-info';
    userInfo.innerHTML = `
      <span class="user-email">${user.email}</span>
    `;
    container.appendChild(userInfo);
  }

  renderLogoutButton(container: HTMLElement): void {
    const button = document.createElement('button');
    button.textContent = 'Logout';
    button.className = 'auth-button logout-button';
    button.onclick = () => this.authManager.logout();
    container.appendChild(button);
  }

  renderAuthStatus(container: HTMLElement): void {
    container.innerHTML = '';
    
    if (this.authManager.isAuthenticated()) {
      const wrapper = document.createElement('div');
      wrapper.className = 'auth-status authenticated';
      this.renderUserInfo(wrapper);
      this.renderLogoutButton(wrapper);
      container.appendChild(wrapper);
    } else {
      const wrapper = document.createElement('div');
      wrapper.className = 'auth-status unauthenticated';
      this.renderLoginButton(wrapper);
      container.appendChild(wrapper);
    }
  }

  showLoadingState(container: HTMLElement): void {
    container.innerHTML = '<div class="auth-loading">Loading...</div>';
  }

  showError(container: HTMLElement, message: string): void {
    const errorDiv = document.createElement('div');
    errorDiv.className = 'auth-error';
    errorDiv.textContent = message;
    container.appendChild(errorDiv);
  }
}
